/**
 * @fileoverview GET handler for the "/search" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { search } from "./constants";
import type { ContentSearchResult } from "./types";

export const getGlobalSearch = reactQueryFetcherAdapter(
  search,
  (
    signal: AbortSignal,
    query: string,
    includeArchive: boolean,
    activeDraftOnly: boolean
  ): Promise<ContentSearchResult> => {
    return fetch(
      "/search",
      "GET",
      { query, include_archive: includeArchive, include_active_draft_only: activeDraftOnly },
      { signal }
    );
  }
);
